import * as actions from './gallery/actions'
import * as contentful from 'contentful'

const client = contentful.createClient({
	accessToken: '08gd4s4McQvdV2KGWwy6SrhSbfuhcjlHLiRZPmVrJFw',
	space: '4tflcka4vyfn',
})

const error = (err) => console.log(err)

export function loadGallery() {
	return (dispatch) =>
		client
			.getEntries({ content_type: 'galleryImage', limit: 20 })
			.then(({ items }) => {
				dispatch(actions.loadImagesSuccess(items))
			})
			.catch(error)
}
